import { render, staticRenderFns } from "./GeneralEmails.vue?vue&type=template&id=094e8757&"
import script from "./GeneralEmails.vue?vue&type=script&lang=js&"
export * from "./GeneralEmails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports